export const defaultFilterDomainState = {
    filmFilters: {},
    showtimeFilters: {},
    subscriptionFilters: {}
};
//# sourceMappingURL=state.js.map